import React from 'react';
import { Box, Typography, Paper } from '@mui/material';
import { useNavigate } from 'react-router-dom';

interface ModuleTileProps {
  title: string;
  icon: React.ReactNode;
  color: string;
  bgLight: string;
  path: string;
}

const ModuleTile: React.FC<ModuleTileProps> = ({
  title,
  icon,
  color,
  bgLight,
  path,
}) => {
  const navigate = useNavigate();

  return (
    <Paper
      elevation={0}
      onClick={() => navigate(path)}
      sx={{
        p: 2,
        height: '100%',
        minHeight: 130,
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        textAlign: 'center',
        cursor: 'pointer',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        bgcolor: 'background.paper',
        transition: 'transform 0.2s ease, box-shadow 0.2s ease, border-color 0.2s ease',
        '&:hover': {
          transform: 'translateY(-4px)',
          boxShadow: '0 12px 24px rgba(15, 23, 42, 0.12)',
          borderColor: color,
        },
      }}
    >
      <Box
        sx={{
          width: 56,
          height: 56,
          borderRadius: 2,
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'center',
          bgcolor: bgLight,
          color,
          mb: 1.5,
          '& svg': { fontSize: 32 },
        }}
      >
        {icon}
      </Box>
      <Typography variant="body2" fontWeight={600} sx={{ lineHeight: 1.3, px: 0.5 }}>
        {title}
      </Typography>
    </Paper>
  );
};

export default ModuleTile;
